/**
 * @description 获取首页配置
 * @author Kody
 */
import Api from '../../path';
import { fetchData } from '@umu/umu-fetch';

export interface IInput {
    action_type: number;
    module_type: number;
    obj_id: string;
    obj_type: number;
}

export const recommendRecord = (data: IInput) => {
    return fetchData(Api.RECOMMEND_RECORD, data).then((res: IResponse<{}>) => {
        return res;
    });
};
